import { atom } from "jotai";
import { ApiTeam } from "src/api/types";
import useApi, { emptyApiState } from "src/hooks/api/utils/useApi";

const stateAtom: any = atom(emptyApiState);

type Options = {
	filter?: any;
};

function useTeams(options?: Options) {
	stateAtom.onMount = (setAtom: any) => {
		setAtom({
			status: "prefetch",
		});
	};
	const { state, actions, api } = useApi(stateAtom, {
		baseUrl: `/company/teams`,
		query: {
			...(options?.filter || {}),
		},
	});
	const teams: ApiTeam[] = state?.list || [];

	const deleteTeam = (id: number | string) => {
		return actions.delete(id).then(() => {
			actions.set((state: any) => ({
				...state,
				list: (state?.list || []).filter(
					(item: ApiTeam) => item.id !== id && item.hid !== id
				),
			}));
		});
	};

	return {
		teams,
		status: state.status,
		actions: {
			...actions,
			delete: deleteTeam,
		},
		api,
	};
}

export default useTeams;
